export default "__VITE_ASSET__CE9ZZ$Eb__"